import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { EditExpensePage } from '@/areas/manufacturing-templates/Expenses/ExpensesCreation/EditExpensePage';
import { canEditManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/expenses/$expenseId/edit')({
    staticData: { access: { permissions: canEditManufacturingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <EditExpensePage {...pathParams} />;
}
